import instance from '@apis/instance';
import { TermCategoryResponse } from '@models/term/termCategory';
import { TermDisplayContext } from '@models/term/termCategory/common';

class TermCategoryApi {
  static getTermCategories(displayContext: TermDisplayContext): Promise<TermCategoryResponse> {
    return instance.get('/terms-categories', { params: { displayContext } });
  }

  static getHistoryCategories(): Promise<TermCategoryResponse> {
    return instance.get('/terms-categories/history');
  }
}

export default TermCategoryApi;
